import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "au-login" }
const _hoisted_2 = { class: "au-login-lang" }
const _hoisted_3 = { class: "au-login-card" }
const _hoisted_4 = { class: "au-login-title" }
const _hoisted_5 = { class: "au-login-subtitle" }
const _hoisted_6 = {
  key: 0,
  class: "au-login-error",
  role: "alert"
}
const _hoisted_7 = {
  key: 0,
  class: "bi bi-box-arrow-in-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguageSwitch = _resolveComponent("LanguageSwitch")!
  const _component_bs5_form_field = _resolveComponent("bs5-form-field")!
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LanguageSwitch)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "au-brand-logo au-login-logo" }, [
        _createElementVNode("i", { class: "bi bi-shield-lock-fill" })
      ], -1)),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("auth.title")), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("auth.subtitle")), 1),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-exclamation-circle-fill" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Form, {
        "validation-schema": _ctx.schema,
        novalidate: "",
        onSubmit: _ctx.login
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bs5_form_field, {
            id: "email",
            name: "login",
            type: "email",
            icon: "bi-envelope",
            autocomplete: "username",
            label: _ctx.$t('auth.email'),
            placeholder: _ctx.$t('auth.emailPlaceholder'),
            modelValue: _ctx.model.login,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.login) = $event))
          }, null, 8, ["label", "placeholder", "modelValue"]),
          _createVNode(_component_bs5_form_field, {
            id: "password",
            name: "password",
            type: "password",
            icon: "bi-lock",
            autocomplete: "current-password",
            label: _ctx.$t('auth.password'),
            placeholder: _ctx.$t('auth.passwordPlaceholder'),
            modelValue: _ctx.model.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.password) = $event))
          }, null, 8, ["label", "placeholder", "modelValue"]),
          _createVNode(_component_bs5_base_button, {
            variant: "primary",
            type: "submit",
            class: "w-100 py-2 mt-2",
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.$t("auth.submit")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["validation-schema", "onSubmit"])
    ])
  ]))
}